export default __webpack_public_path__ + "7460140675d08947cc542c1ba6c1bd4f.svg";